class GiftWithPurchaseProgressBar extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.setupListeners()

    this.handleProgressBar()
  }

  async getCartInfo () {
    try {
      const cart = await fetch('/cart.js').then(res => res.json())

      const cartTotal = cart.items.reduce((total, item) => {
        const keys = Object.keys(item.properties || {})
        if (!keys.includes('_hiddenFreeGift')) {
          return total + item.final_line_price
        } else {
          return total
        }
      }, 0)

      const cartItems = cart.items

      console.info('Fetched cart info:', { cartTotal, cartItems })

      return { cartTotal, cartItems }
    } catch (error) {
      console.error('Error fetching cart total:', error.message)
      return { cartTotal: 0, cartItems: [] }
    }
  }

  setupListeners () {
    document.addEventListener('gwpProgressBarUpdate', (e) => {
      this.handleProgressBar()
    })

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-gift-with-purchase-el="progress_close"]')) {
        document.querySelectorAll('[data-gift-with-purchase-el="progress_bar"]').forEach(progressBar => {
          progressBar.remove()
        })
      }
    })
  }

  async handleProgressBar () {
    const { cartTotal, cartItems } = await this.getCartInfo()
    if (cartItems.length === 0) return

    const gwpCartItems = document.querySelectorAll('[data-gift-with-purchase-el="progress_bar"]')
    gwpCartItems.forEach(item => {
      const minCartValue = item.dataset.minCartValue
      this.innerHTML = ''
      item.setAttribute('aria-hidden', 'false')

      const remainingValueEl = item.querySelector('[data-gift-with-purchase-el="remainingSpend"')

      const formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: remainingValueEl.dataset.currency,
      })

      const remainingSpend = formatter.format((minCartValue - cartTotal) / 100)
      remainingSpend.replace('US', '').trim()
      remainingValueEl.innerHTML = remainingSpend

      const progressBarEl = item.querySelector('[data-gift-with-purchase-el="bar"]')
      const percentage = Math.min((cartTotal / minCartValue) * 100, 100)
      progressBarEl.style.width = `${percentage}%`

      const gwpCartItemClone = item.cloneNode(true)

      if (cartTotal < minCartValue && (minCartValue - cartTotal) !== minCartValue) {
        this.prepend(gwpCartItemClone)
      }
    })
  }
}

if (!window.customElements.get('gift-with-purchase-progress-bar')) {
  window.customElements.define('gift-with-purchase-progress-bar', GiftWithPurchaseProgressBar)
}
